import http from "./httpService";

const apiEndpoint = process.env.REACT_APP_CONTACT_URL;

export function saveContact(data) {
  return http.post(apiEndpoint, data);
}
